export default __webpack_public_path__ + "svg/banner/mentors.svg?27a0f3b5";